import "./Services.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import SupplyChainPillars from "./sections/SupplyChainPillars";
import SupplyChainProcess from "./sections/SupplyChainProcess";
import MelbourneServiceZone from "./sections/MelbourneServiceZone";
import EngineeringFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <PrimaryNavigation />
      <SupplyChainPillars />
      <SupplyChainProcess />
      <MelbourneServiceZone />
      <EngineeringFooter />
    </div>;
}